import { customElement } from "lit/decorators.js";
import { nothing, TemplateResult } from "lit";
import { DodonaElement } from "@/components/meta/dodona_element";
import { calloutTemplate } from "@/callout";
import { I18n } from "@/i18n/i18n";

/**
 * Congratulates the user on a correct submission and links to the next activity of the series.
 * The feedback of a submission does not know its series, so the link comes from the
 * `#next-exercise-link` of the activity page it is loaded into. Renders nothing elsewhere.
 *
 * @element d-next-activity-callout
 */
@customElement("d-next-activity-callout")
export class NextActivityCallout extends DodonaElement {
    // i18n-tasks-use t('js.submission_motivational_message.1') t('js.submission_motivational_message.2') t('js.submission_motivational_message.3') t('js.submission_motivational_message.4') t('js.submission_motivational_message.5') t('js.submission_motivational_message.6')
    private readonly messageKey = `js.submission_motivational_message.${Math.ceil(Math.random() * 6)}`;

    render(): TemplateResult | typeof nothing {
        const link = document.getElementById("next-exercise-link") as HTMLAnchorElement | null;
        if (!link) return nothing;

        return calloutTemplate({
            type: "success",
            icon: "check-circle-outline",
            message: I18n.t(this.messageKey),
            action: { label: link.dataset.title, href: link.href },
        });
    }
}
